import { useContext } from 'react';

import { BrandContext } from 'context/BrandContext';
import { isStandardVariant } from 'helpers/iconSizes';
import { ICON_SIZES } from 'lib/constants/iconSizes';

const Repeat = ({ svgSize = ICON_SIZES.MD, className = '' }) => {
  const { theme } = useContext(BrandContext);
  const isStandardVariantIcon = isStandardVariant(svgSize);

  if (isStandardVariantIcon) {
    return (
      <svg
        width={svgSize}
        height={svgSize}
        className={className}
        viewBox="0 0 32 32"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M25 16C25 20.9706 20.9706 25 16 25C11.0294 25 7 20.9706 7 16C7 11.0295 11.0294 7.00001 16 7.00001C20.9706 7.00001 25 11.0295 25 16Z"
          fill={theme.icon.fill}
        />
        <path
          d="M27.0704 14.1053C27.4357 14.0669 27.7634 14.3319 27.8019 14.6971C27.9879 16.4637 27.7772 18.2497 27.1857 19.9247C26.5941 21.5997 25.6362 23.1218 24.382 24.3798L24.381 24.3807C19.747 29.0147 12.2461 29.0252 7.61733 24.3964L6.76576 23.5448V27.8993C6.76576 28.2665 6.46784 28.5651 6.10072 28.5653C5.73376 28.5653 5.4361 28.2671 5.43568 27.9003V22.0096L5.44838 21.8778C5.50909 21.5777 5.77226 21.3506 6.08998 21.3456L12.0685 21.2567C12.4353 21.2516 12.7367 21.5451 12.7423 21.912C12.7476 22.279 12.4551 22.5812 12.088 22.5868L7.75209 22.6503L8.55775 23.4559C12.6651 27.5632 19.3231 27.5562 23.4396 23.4403C24.5542 22.3224 25.406 20.9699 25.9318 19.4813C26.4574 17.9928 26.645 16.4057 26.4796 14.8358C26.4412 14.4707 26.7054 14.144 27.0704 14.1053ZM25.8996 3.43542C26.2666 3.43552 26.5644 3.73342 26.5646 4.10046V9.99011C26.5643 10.3532 26.2723 10.6496 25.9093 10.6552L19.9318 10.7421C19.5649 10.7475 19.2629 10.4555 19.257 10.0887C19.2515 9.72166 19.5452 9.41862 19.9122 9.41296L24.2013 9.34949L23.4171 8.56531C19.3146 4.46276 12.651 4.46824 8.53627 8.58289L8.53529 8.58386C7.41506 9.70142 6.56197 11.0575 6.03822 12.5507C5.51447 14.0439 5.33315 15.6363 5.5099 17.2089C5.55075 17.5737 5.28786 17.9032 4.92299 17.9442C4.5583 17.9848 4.22962 17.7211 4.18861 17.3563C3.98966 15.5853 4.19251 13.792 4.78236 12.1102C5.37228 10.4284 6.33508 8.90221 7.59682 7.64343C12.2289 3.01151 19.7336 3.00024 24.3576 7.6239L25.2335 8.49988L25.2345 4.10046C25.2347 3.7334 25.5325 3.43548 25.8996 3.43542Z"
          fill={theme.icon.stroke}
          fillRule="evenodd"
        />
      </svg>
    );
  }

  return (
    <svg
      width={svgSize}
      height={svgSize}
      className={className}
      viewBox="0 0 56 56"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M43.75 28C43.75 36.8366 36.5866 44 27.75 44C18.9134 44 11.75 36.8366 11.75 28C11.75 19.1635 18.9134 12 27.75 12C36.5866 12 43.75 19.1635 43.75 28Z"
        fill={theme.icon.fill}
      />
      <path
        d="M47.4046 24.9709C47.8851 24.9204 48.3159 25.2687 48.3665 25.7492C48.6876 28.7983 48.3239 31.8807 47.303 34.7717C46.282 37.6626 44.6289 40.29 42.4641 42.4611L42.4622 42.4631C34.4651 50.4596 21.5215 50.4774 13.5344 42.4904L11.551 40.507V47.3234C11.551 47.8066 11.1592 48.1993 10.676 48.1994C10.193 48.1994 9.80136 47.8074 9.80104 47.3244V38.5178L9.80593 38.4299C9.84967 37.9937 10.2139 37.6515 10.6614 37.6438L19.6214 37.4885C20.1043 37.4803 20.5034 37.865 20.512 38.3479C20.5203 38.8307 20.1353 39.2297 19.6526 39.2385L12.8743 39.3547L14.7717 41.2531C22.0727 48.5541 33.9076 48.54 41.2239 41.2248C43.2049 39.238 44.7192 36.8352 45.6536 34.1897C46.588 31.5439 46.9192 28.7223 46.6253 25.9318C46.5749 25.4514 46.9241 25.0215 47.4046 24.9709ZM13.4973 13.5793C21.4911 5.58549 34.4414 5.56863 42.4202 13.5471L44.4485 15.5754L44.4495 8.67501C44.4499 8.19214 44.8415 7.80007 45.3245 7.80001C45.8073 7.80019 46.1991 8.19222 46.1995 8.67501V17.4816C46.1994 17.959 45.8164 18.3474 45.3391 18.3557L36.3782 18.5109C35.8953 18.519 35.4969 18.1336 35.4885 17.6506C35.4807 17.1678 35.866 16.7693 36.3489 16.7609L43.0432 16.6447L41.1829 14.7844C33.8901 7.492 22.0467 7.50258 14.7337 14.8156V14.8166C12.7422 16.8032 11.2233 19.2131 10.2923 21.8674C9.36137 24.5215 9.04162 27.3517 9.35573 30.1467C9.40968 30.6266 9.06496 31.06 8.58522 31.1145C8.10512 31.1684 7.67161 30.823 7.61745 30.343C7.27384 27.2862 7.62377 24.1909 8.64186 21.2883C9.65984 18.386 11.32 15.7515 13.4973 13.5793Z"
        fill={theme.icon.stroke}
        fillRule="evenodd"
      />
    </svg>
  );
};

Repeat.propTypes = {
  className: PropTypes.string,
  svgSize: PropTypes.oneOf(Object.values(ICON_SIZES)),
};

export default Repeat;
